import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { injectIntl, intlShape } from 'react-intl';
import Header from '../../../components/Header/Header';
import { withRouter, Link } from 'react-router';
import { Button } from 'react-bootstrap';

import { chooseHost, getHosts } from '../AuthActions';

import { PAGES, trackPageView } from '../../../util/mixpanel';

import profileIcon from '../../../assets/images/profile-icon.svg';

// Import Style
import '../Auth.scss';

class SelectHostPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hosts: []
    };
  }
  componentDidMount() {
    if (!this.props.hosts.length) {
      this.props.getHosts();
    }
  }

  handleSubmit = host => {
    this.props.chooseHost(host).then(
      () => {
        this.props.router.replace(`/login${this.props.location.search}`);
      },
      err => {}
    );
  };

  render() {
    trackPageView(PAGES.HOSTS);
    const { hosts, selected } = this.props;
    return (
      <div className='main select-host'>
        <Header title="" showHome={false} />
        <div className='select-host-scroll'>
          <div className='select-host-container'>
            <div className='select-host-head'>
              <h1>Welcome!</h1>
              <p>We noticed you authorized Nave to access multiple sites.</p>
              <p>Which one would you like to proceed with?</p>
            </div>

            <div className='select-host-lists'>
              {hosts &&
                hosts.map((host, i) => {
                  return (
                    <div className='select-host-item'>
                      <div className='select-host-item-content'>
                        <div className='message'>{host.url}</div>
                        <div className='icon'><img src={profileIcon} alt="" /></div>
                      </div>
                      
                      <Button onClick={() => this.handleSubmit(host)} variant="secondary">
                        Connect
                      </Button>
                    </div>
                  );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SelectHostPage.propTypes = {
  intl: intlShape.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    chooseHost: body => dispatch(chooseHost(body)),
    getHosts: () => dispatch(getHosts())
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
    hosts: state.auth.hosts
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SelectHostPage)));
